import React, { useMemo} from 'react';
import styles from './PresentationsWithSections.module.scss';

import { Content, Lesson } from '@types';
import { LessonType, LastVisitedLessonContentFragment, SectionFragment, Section } from '@api/graphql-codegen';
import LessonsAccordionBySections from '@src/components/program-details/lesson/lesson-section/LessonsAccordionBySections';

type Props = {
  contents: Content[] | undefined;
  sections: SectionFragment[];
  lesson: Lesson | undefined;
  lessonType: LessonType | undefined;
  lessonOpened: boolean;
  lastVisitedLesson?: LastVisitedLessonContentFragment;
  closeNav?: () => void;
  startLesson: (lesson: Lesson) => void;
  startExercise?: (exercise: Section, isFromPreview?: boolean) => void;
};

function PresentationsWithSections(props: Props) {
  const { contents = [], lesson, lessonOpened, lastVisitedLesson, sections, closeNav, startLesson, startExercise} = props;

  const wrapperClassName = useMemo(() => {
    const classes = [styles.wrapper];
    if (lessonOpened) {
      classes.push(styles.opened);
    }

    return classes.join(' ');
  }, [lessonOpened]);
  
  return (
    <div className={wrapperClassName}>
      <div className={styles.content}>
        <LessonsAccordionBySections title={lesson?.name || ""} sections={sections} lesson={lesson as Lesson} contents={contents} lastVisitedLesson={lastVisitedLesson} closeNav={closeNav} startLesson={startLesson} startExercise={startExercise}/>
      </div>
    </div>
  );
}

export default React.memo(PresentationsWithSections);
